import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Navbar.css";

const Navbar = () => {
  const [navOpen, setNavOpen] = useState(false);
  const location = useLocation();

  const handleToggle = () => setNavOpen((open) => !open);
  const closeMenu = () => setNavOpen(false);

  const handleLogout = () => {
    localStorage.removeItem("token");
    window.location.reload();
  };

  return (
    <nav className="navbar">
      <div className="navbar-content">
        <Link to="/" className="navbar-brand" onClick={closeMenu}>
          <span role="img" aria-label="chantier">
            🏗️
          </span>
          <span className="brand-text">MOBIL PLUS</span>
        </Link>
        <button
          className={`navbar-toggle${navOpen ? " open" : ""}`}
          onClick={handleToggle}
          aria-label="Menu"
          aria-expanded={navOpen}
        >
          <span className="bar" />
          <span className="bar" />
          <span className="bar" />
        </button>
        <ul className={`navbar-nav${navOpen ? " show" : ""}`}>
          <li>
            <Link
              to="/"
              className={`navbar-link${
                location.pathname === "/" ? " active" : ""
              }`}
              onClick={closeMenu}
            >
              Accueil
            </Link>
          </li>
          <li>
            <Link
              to="/chantiers"
              className={`navbar-link${
                location.pathname.startsWith("/chantiers") ? " active" : ""
              }`}
              onClick={closeMenu}
            >
              Mes Chantiers
            </Link>
          </li>
          
          <li>
            <Link
              to="/salaries"
              className={`navbar-link${
                location.pathname === "/salaries" ? " active" : ""
              }`}
              onClick={closeMenu}
            >
              Tous les salariés
            </Link>
          </li>
          <li>
            <Link
              to="/fournisseurs"
              className={`navbar-link${
                location.pathname === "/fournisseurs" ? " active" : ""
              }`}
              onClick={closeMenu}
            >
              Tous les fournisseurs
            </Link>
          </li>
          <li>
            <Link
              to="/prix-ouvrage"
              className={`navbar-link${
                location.pathname === "/prix-ouvrage" ? " active" : ""
              }`}
              onClick={closeMenu}
            >
              Charges fixes
            </Link>
          </li>
          
          <li>
            <Link
              to="/frais-transport"
              className={`navbar-link${
                location.pathname.startsWith("/frais-transport") ? " active" : ""
              }`}
              onClick={closeMenu}
              style={{ fontWeight: 600, color: "#1976d2" }}
            >
              🚚 Frais Transport
            </Link>
          </li>
          <li>
            <Link
              to="/prestations"
              className={`navbar-link${
                location.pathname === "/prestations" ? " active" : ""
              }`}
              onClick={closeMenu}
            >
              Prestations
            </Link>
          </li>
          <li>
            <Link
              to="/plombiers"
              className={`navbar-link${
                location.pathname === "/plombiers" ? " active" : ""
              }`}
              onClick={closeMenu}
            >
              Plombiers
            </Link>
          </li>
          <li>
            <Link
              to="/prestation-stats"
              className={`navbar-link${
                location.pathname === "/prestation-stats" ? " active" : ""
              }`}
              onClick={closeMenu}
            >
               Stats Prestations
            </Link>
          </li>
        </ul>
      </div>
      <div className="navbar-actions">
        <button className="logout-btn" onClick={handleLogout}>
          Logout
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
